<style scoped>
.custom-container {
  padding: 20px;
}

.custom-container .card {
  box-shadow: unset;
}

.custom-container .p-tabpanels {
  padding-left: 0;
  padding-right: 0;
}

.custom-container .p-accordionheader {
  padding-left: 0;
}

.custom-container .p-accordionheader p {
  margin: 0;
}

.custom-container .p-accordionheader .stato-esecutore {
  margin-right: auto;
  margin-left: 20px;
}

.row-tasks {
  grid-gap: 20px;
  align-items: center;
}


.bottone-assegna-attivita {
  width: 40px;
  height: 40px;
}

.test-button {
  position: fixed;
  top: 30px;
  right: 30px;
  z-index: 9999999999999;
}

.nome-esecutore {
  width: 350px;
}

.row-hidden {
  position: absolute;
  width: calc(100vw - 20px);
  opacity: 0;
  visibility: hidden;
  top: 0;
  z-index: -1;
}

.label-notifica {
  font-weight: 400;
  margin: 0 0 0 10px;
}

.attivita {
  padding: 10px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  border-radius: 10px;
  margin-bottom: 10px;
}

.attivita p {
  margin: 0;
  font-size: 12px;
}

.row-tasks {
  transform: none;
  width: 100%;
  transition: transform 0.5s, width 0.5s;
}

.row-tasks.drawer-opened {
  transform: translateX(calc(40vw - 80px));
  width: 60vw;
}

.task-container.expanded {
  width: calc(70% - 30px);
}

.task-container.collapsed {
  width: calc(10% - 30px);
}

.row-tasks.drawer-opened .task-container.expanded {
  width: calc(55% - 30px);
}

.row-tasks.drawer-opened .task-container.collapsed {
  width: calc(15% - 30px);
}

.row-filtro-attivita {
  padding: 20px 0 30px 0;
}

.row-filtro-attivita input {
  width: 100%;
}

.p-button {
  font-size: 12px !important;
}

.stato-esecutore {
  display: flex;
  grid-column-gap: 40px;

}
.testo-red{
  color: red;
}
</style>

<template>

  <div class="custom-container">
    <div class="filtri">
      <k-filtri-dashboard :is-p-m="true"></k-filtri-dashboard>
    </div>
    <div class="lista-accordion">
      <Tabs value="1">
        <TabList>
          <Tab v-show="filtraAmbiti(item)"
               v-for="(item, index) in ambiti" :key="item.label" :value="index" @click="toggleTab($event, index)">
            {{ item.label }}<br>
            {{ item.count }}
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel v-for="(item, index) in ambiti" :key="item.label" :value="index">
            <Accordion :value="[item.label]" multiple>
              <AccordionPanel v-show="filtraEsecutori(esecutore)"
                              v-for="(esecutore) in item.esecutori" :key="esecutore.id_account"
                              :value="esecutore.id_account"
                              class="accordion-esecutore">
                <AccordionHeader>
                  <p class="nome nome-esecutore">{{ esecutore.descrizione }}</p>
                  <div class="stato-esecutore">
                    <div class="counter carico">
                      <p class="small">
                        Carico sprint: {{ esecutore.caricoTODO }} /
                        {{ getCaricoMassimoSettimana(esecutore.orarioSettimanale, esecutore) }}
                      </p>
                      <p class="small">
                        Next sprint:  {{ esecutore.caricoSettimanaProssimaTodo }} / {{ getCaricoMassimoSettimanaProssima(esecutore.orarioSettimanale, esecutore) }}
                      </p>
                      <p class="small">
                        BACKLOG: {{ esecutore.caricoSettimanaProssimaBacklog }}
                      </p>
                    </div>
                    <div class="counter carico">
                      <p class="small">
                        in progress:  {{ esecutore.taskInProgress }}
                      </p>
                      <p v-if="esecutore.feedbackStimaWaiting>0" class="small">
                        stima da confermare:  {{ esecutore.feedbackStimaWaiting }}
                      </p>
                      <p v-if="esecutore.feedbackStimaOK>0" class="small">
                        stima confermata:  {{ esecutore.feedbackStimaOK }}
                      </p>

                      <p v-if="esecutore.feedbackStimaKO>0" class="small testo-red">
                        stima rifiutata:  {{ esecutore.feedbackStimaKO }}
                      </p>
                      <p v-if="esecutore.feedbackEffortRevisionRequested>0" class="small testo-red">
                        richiesta di altro tempo:  {{ esecutore.feedbackEffortRevisionRequested }}
                      </p>


                    </div>
                  </div>
                </AccordionHeader>
                <AccordionContent>
                  <div class="container-fluid" style="padding: 20px 0 0 0 !important;">
                    <div class="row row-tasks" :class="showAttivitaUtente?'drawer-opened':''">
                      <CustomButton title="Attività assegnate all'esecutore" class="bottone-assegna-attivita"
                                    icon="pi pi-search-plus"
                                    @click="openAttivitaUtente(esecutore.descrizione, esecutore.id_account)"/>
                      <k-task-container :user-id="esecutore.id_account" :task-status="'BACKLOG'"
                                        :is-p-m="true"></k-task-container>
                      <k-task-container :user-id="esecutore.id_account" :expanded-on-start="true"  :allow-feedback-ts="false"
                                        :task-status="'TODO'" :is-p-m="true"></k-task-container>
                      <k-task-container :user-id="esecutore.id_account" :task-status="'REVIEW'"
                                        :is-p-m="true"></k-task-container>
                      <k-task-container :user-id="esecutore.id_account" :task-status="'DONE'"
                                        :is-p-m="true"></k-task-container>
                    </div>
                  </div>
                </AccordionContent>
              </AccordionPanel>
            </Accordion>
          </TabPanel>
        </TabPanels>
      </Tabs>

    </div>
    <div class="container-notifiche">
      <tabella-notifiche></tabella-notifiche>
    </div>
  </div>

  <CustomDialog v-model:visible="showCloseTicket" modal header="Tutti i Task Sprint completati"
                :style="{ width: '700px' }">
    <span class="text-surface-500 dark:text-surface-400 block mb-8">{{ titoloDialog }}</span>
    <div class="flex justify-end gap-2" style="grid-gap: 20px; display: flex; margin-top: 20px">
      <CustomButton type="button" label="Non fare niente" severity="secondary"
                    @click="showCloseTicket=false"></CustomButton>
      <CustomButton type="button" label="Crea nuovo Task Sprint" severity="primary" @click="creaNuovoTS"></CustomButton>
      <CustomButton type="button" severity="primary" label="Chiudi il ticket" @click="chiudiTicket"></CustomButton>
      <CustomButton type="button" severity="primary" label="Chiudi definitivamente il ticket"
                    @click="startChiudiDefinitivoTicket"></CustomButton>
    </div>
  </CustomDialog>


  <CustomDialog v-model:visible="showRiProgrammaTask" modal :header="titleRiprogrammaTS" :style="{ width: '700px' }">
    <div class="row" style="margin-top: 20px">
      <div class="col-md-6 col-12">
        <div class="flex flex-col gap-1">
          <FloatLabel variant="on" class="w-full md:w-56">
            <DatePicker v-model="vecchiaDataTs" :disabled="true" fluid dateFormat="dd/mm/yy"/>
            <label for="over_label">Data attuale inizio del Task</label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-md-6 col-12">
        <div class="flex flex-col gap-1">
          <FloatLabel variant="on" class="w-full md:w-56">
            <DatePicker v-model="nuovaDataTs" :minDate="new Date()" fluid dateFormat="dd/mm/yy"/>
            <label for="over_label">Nuova data inizio del Task</label>
          </FloatLabel>
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-2" style="grid-gap: 40px; display: flex; margin-top: 40px">
      <CustomButton type="button" label="Annulla" severity="secondary"
                    @click="showRiProgrammaTask=false"></CustomButton>
      <CustomButton type="button" label="Salva" severity="primary" @click="salvaRiprogrammazione"></CustomButton>
    </div>
  </CustomDialog>

  <CustomDialog v-model:visible="showChiudiDefinitivo" modal
                :header="'Stai chiudendo definitivamente il ticket n.'+task.idTicket" :style="{ width: '700px' }">
    <div class="row" style="margin-top: 20px">
      <div class="col-12">
        <div class="flex flex-col gap-1">
          <FloatLabel variant="on" class="w-full md:w-56">
            <CustomTextArea v-model="messaggioChiusuraDefinitivo" rows="5" cols="10"/>
            <label for="over_label">Messaggio di chiusura</label>
          </FloatLabel>
        </div>
      </div>
      <div class="col-4" style="margin-top: 20px">
        <div class="flex items-center gap-2">
          <Checkbox v-model="inviaNotifica" inputId="inviaNotifica" binary/>
          <label class="label-notifica" for="inviaNotifica"> Invia notifica </label>
        </div>
      </div>
    </div>

    <div class="flex justify-end gap-2" style="grid-gap: 40px; display: flex; margin-top: 40px">
      <CustomButton type="button" label="Annulla" severity="secondary"
                    @click="showChiudiDefinitivo=false"></CustomButton>
      <CustomButton type="button" label="Conferma" severity="primary" @click="chiudiDefinitivoTicket"></CustomButton>
    </div>
  </CustomDialog>

  <Drawer class="drawer-attivita" v-model:visible="showAttivitaUtente" :header="titoloDrawerAttivitaUtente"
          :modal="false" :blockScroll="true" :dismissable="false" style="width: 40vw" :auto-z-index="false"
          :base-z-index="99">
    <div class="row-filtro-attivita">
      <FloatLabel variant="on">
        <InputText id="attivita_inline" v-model="attivitaInline"/>
        <label for="attivita_inline">Attività</label>
      </FloatLabel>
    </div>
    <div class="lista-attivita">
      <div class="attivita"
           v-for="(item, index) in listaAttivitaUtente.filter(att=>att.titolo.toLowerCase().includes(attivitaInline.toLowerCase()) || att.id_ticket.toString().includes(attivitaInline))"
           :key="item.id_ticket" draggable="true" @dragstart="startDrag($event, item)">
        <p><b>Attività:</b> {{ item.titolo }} - <b>{{ item.id_ticket }}</b></p>
        <p><b>Lavoro:</b> {{ item.lavoro }} </p>
        <p><b>Anagrafica:</b> {{ item.id_anagrafica_relazione_lbl }}</p>
      </div>
    </div>
  </Drawer>


  <k-modal-gestione-notifica></k-modal-gestione-notifica>
  <k-modal-messaggio-task></k-modal-messaggio-task>
  <k-simple-modal></k-simple-modal>
  <k-modal-edit-task></k-modal-edit-task>
  <k-modal-crea-task-sprint></k-modal-crea-task-sprint>
  <k-modal-cambia-esecutore></k-modal-cambia-esecutore>
  <k-modal-dettaglio-ticket></k-modal-dettaglio-ticket>
  <k-modal-dettaglio-notifica></k-modal-dettaglio-notifica>
  <k-modal-storico-task></k-modal-storico-task>
  <k-modal-crea-attivita></k-modal-crea-attivita>


  <!--  <div class="container-fluid p-4">-->
  <!--    <div class="row row-tasks row-hidden">-->
  <!--      <k-task-container :user-id="-1" :task-status="'BACKLOG'"-->
  <!--                        :is-p-m="true"></k-task-container>-->
  <!--      <k-task-container :user-id="-1" :expanded-on-start="true"-->
  <!--                        :task-status="'TODO'" :is-p-m="true"></k-task-container>-->
  <!--      <k-task-container :user-id="-1" :task-status="'REVIEW'"-->
  <!--                        :is-p-m="true"></k-task-container>-->
  <!--      <k-task-container :user-id="-1" :task-status="'DONE'"-->
  <!--                        :is-p-m="true"></k-task-container>-->
  <!--    </div>-->
  <!--  </div>-->

</template>


<script>
import * as $ from 'jquery';
import Tabs from 'primevue/tabs';
import TabList from 'primevue/tablist';
import Tab from 'primevue/tab';
import TabPanels from 'primevue/tabpanels';
import TabPanel from 'primevue/tabpanel';
import moment from "moment/moment";
import DatePicker from 'primevue/datepicker';
import Checkbox from 'primevue/checkbox';
import Drawer from 'primevue/drawer';
import KTaskContainer from "@/views/taskSprint/components/task-container.vue";
import KModalEditTask from "@/views/taskSprint/components/modal-edit-task.vue"
import KSimpleModal from "@/views/taskSprint/components/simple-modal.vue";
import Accordion from 'primevue/accordion';
import AccordionPanel from 'primevue/accordionpanel';
import AccordionHeader from 'primevue/accordionheader';
import AccordionContent from 'primevue/accordioncontent';
import KModalCreaTaskSprint from '@/views/taskSprint/components/modal-crea-task.vue';
import KModalCambiaEsecutore from "@/views/taskSprint/components/modal-cambia-esecutore.vue";
import KFiltriDashboard from "@/views/taskSprint/dashboard/components/filtri.vue";
import KModalDettaglioTicket from "@/views/taskSprint/components/modal-dettaglio-ticket.vue";
import KModalMessaggioTask from "@/views/taskSprint/components/modal-messaggio-task.vue";
import TabellaNotifiche from "@/views/taskSprint/notifiche/tabella-notifiche.vue";
import KModalGestioneNotifica from "@/views/taskSprint/notifiche/modal-gestione-notifica.vue";
import CustomButton from "primevue/button";
import KModalDettaglioNotifica from "@/views/taskSprint/components/modal-dettaglio-notifica.vue";
import KModalStoricoTask from "@/views/taskSprint/components/modal-storico-task.vue";
import axios from "axios";
import CustomDialog from 'primevue/dialog';
import FloatLabel from 'primevue/floatlabel';
import CustomTextArea from "primevue/textarea";
import InputText from 'primevue/inputtext';
import KModalCreaAttivita from "@/views/taskSprint/components/modal-crea-attivita.vue";

export default {
  name: "newDashboardPM",
  components: {
    KModalCreaAttivita,
    CustomTextArea,
    KModalStoricoTask,
    KModalDettaglioNotifica,
    KModalGestioneNotifica,
    TabellaNotifiche,
    KModalMessaggioTask,
    Tab,
    Tabs,
    TabList,
    TabPanels,
    TabPanel,
    KModalCambiaEsecutore,
    KTaskContainer,
    KModalEditTask,
    KSimpleModal,
    Accordion,
    AccordionPanel,
    AccordionHeader,
    AccordionContent,
    KModalCreaTaskSprint,
    KFiltriDashboard,
    KModalDettaglioTicket,
    CustomButton,
    CustomDialog,
    DatePicker,
    FloatLabel,
    Checkbox,
    Drawer,
    InputText
  },
  emits: ["show-modal"],
  data() {
    return {
      selectedTask: {},
      loggedUser: {},
      loading: true,
      contexts: [],
      hoveredIndex: null,
      esecutori: [],
      ambiti: [],
      filtroInline: '',
      filtriClient: null,
      activeTab: null,
      showCloseTicket: false,
      titoloDialog: '',
      task: {},
      force: false,
      oldStatus: '',
      newStatus: '',
      showRiProgrammaTask: false,
      programmaPayload: null,
      titleRiprogrammaTS: '',
      vecchiaDataTs: new Date(),
      nuovaDataTs: new Date(),
      tsDaRiprogrammare: null,
      showChiudiDefinitivo: false,
      messaggioChiusuraDefinitivo: '',
      inviaNotifica: false,
      showAttivitaUtente: false,
      listaAttivitaUtente: [],
      titoloDrawerAttivitaUtente: '',
      idUserCreaDaAttivita: -1,
      attivitaInline: ''
    };
  },
  computed: {
    isLoading() {
      return this.loading;
    }
  },
  mounted() {
    this.load();
  },
  setup() {
  },
  created() {
    this.$store.dispatch("initializeSocket", sessionStorage.getItem('ACCESS_TOKEN'))

    this.$store.subscribe(async (mutation, state) => {
      if (mutation.type === 'taskLoadedPM') {
        if (this.$store.getters.getFiltriRequest().idTicket) {
          this.$store.dispatch('applicaFiltriClient', {
            idEsecutore: -1,
            idLavoro: -1,
            idAttivita: parseInt(this.$store.getters.getFiltriRequest().idTicket)
          });
        }
      }
      if (mutation.type === 'esecutoriLoaded') {
        //this.$store.getters.getAmbiti();
        this.ambiti = [...this.$store.getters.getAmbiti()]
        this.$store.dispatch('loadTasksForPM', {});
        this.$store.dispatch("loadLavori");
        this.$store.dispatch("loadAttivitaSenzaLavoro");
        this.$store.dispatch("loadTutteLeAttivita");
        this.$store.dispatch("loadNotifiche");
        const config = {
          headers: {Authorization: `Bearer ${sessionStorage.getItem('ACCESS_TOKEN')}`}
        };
        let request = axios.post(process.env.VUE_APP_TASK_SPRINT_API + "/task-sprint/getConfigForUserFromToken", {}, {...config});
        let response = await request;
        let userDataToken = JSON.parse(response.data.result);
        sessionStorage.setItem('userId', userDataToken.user.userId)
        sessionStorage.setItem('ticketCategorie', JSON.stringify(userDataToken.idTicketCategorie))

      }
      if (mutation.type === 'filtraEsecutori') {
        let filtrati = [];
        if (mutation.payload === -1) {
          filtrati = this.$store.getters.getEsecutori();
        } else {
          filtrati = this.$store.getters.getEsecutoriFilter(mutation.payload);
        }

        this.esecutori = [...filtrati]
      }
      if (mutation.type === 'filtraEsecutoriInline') {
        this.filtroInline = mutation.payload.esecutore;
      }
      if (mutation.type === 'tuttiITaskCompletati') {
        let task = {...mutation.payload.task};
        let canCloseTicket = mutation.payload.canCloseTicket;
        let attivita = this.$store.getters.getTicket(task.idTicket);
        let esecutore = this.$store.getters.getEsecutoriFilter(task.idOwner + "");
        this.force = mutation.payload.force;


        if (!canCloseTicket) {
          this.$confirm.require({
            message: "Tutti i Task Sprint per l'attività " + attivita[0]?.titolo + " sono in stato DONE, vuoi crearne altri?",
            header: "L'esecutore " + esecutore[0]?.descrizione + " ha completato tutti i TS per l'attività " + attivita[0]?.titolo,
            icon: 'pi pi-exclamation-triangle',
            blockScroll: true,
            rejectProps: {
              label: 'No',
              severity: 'secondary',
              outlined: true
            },
            acceptProps: {
              label: 'Si'
            },
            accept: () => {
              task.descrizione = undefined;
              task.richiedeApprovazione = undefined;
              task.orePreviste = undefined;
              task.orePreviste = undefined;
              this.$store.dispatch('creaTaskSprint', {
                userId: task.idOwner,
                status: "BACKLOG",
                duplica: true,
                task: {...task}
              });
            },
            reject: () => {
              console.log('');
            }
          });
        } else {
          this.showCloseTicket = true;
          this.messaggioChiusuraDefinitivo = mutation.payload.messaggioNotifica;
          this.titoloDialog = "Tutti i Task Sprint per l'attività " + attivita[0]?.titolo + " sono in stato DONE, vuoi crearne altri o chiudere il ticket";
          this.task = {...task};
        }
      }
      if (mutation.type === 'filtraTasks') {
        this.filtriClient = mutation.payload;
        // if (mutation.payload.idAttivita === -1 && mutation.payload.idLavoro === -1) {
        //   let tasks = [...this.$store.getters.getByStatusAndUser(this.taskStatus, this.userId)];
        //   this.tasks = [...tasks];
        // } else {
        //   let tasks = [...this.$store.getters.getFiltrati(this.taskStatus, this.userId, mutation.payload)];
        //   this.tasks = [...tasks];
        // }
      }
      if (mutation.type === 'startProgrammaTs') {
        this.showProgrammaTask = true;
        this.programmaPayload = mutation.payload;
      }
      if (mutation.type === 'startRiprogrammaTs') {
        this.tsDaRiprogrammare = mutation.payload;
        this.showRiProgrammaTask = true;
        this.vecchiaDataTs = moment.unix(this.tsDaRiprogrammare.startDate).toDate();
        this.nuovaDataTs = new Date()
      }
      if (mutation.type === 'attivitaUtenteLoaded') {
        this.listaAttivitaUtente = [...mutation.payload]
      }
      if (mutation.type === 'taskDaAggiornare') {
        if (mutation.payload?.length > 0)
          this.$store.dispatch('aggiornaTaskSprint', mutation.payload);
      }
    })
  },
  methods: {
    startDrag(evt, item) {
      evt.dataTransfer.dropEffect = 'move'
      evt.dataTransfer.effectAllowed = 'move'
      evt.dataTransfer.setData('element', JSON.stringify({
        ...item,
        creaDaAttivita: true,
        userId: this.idUserCreaDaAttivita
      }))
    },
    openAttivitaUtente(nomeUtente, idUtente) {
      this.idUserCreaDaAttivita = idUtente;
      this.showAttivitaUtente = true;
      this.titoloDrawerAttivitaUtente = "Attività assegnate a " + nomeUtente
      this.$store.dispatch('loadAttivitaUtente', idUtente);
    },
    salvaRiprogrammazione() {
      this.tsDaRiprogrammare.startDate = moment(this.nuovaDataTs).unix()
      this.$store.dispatch('editTask', {...this.tsDaRiprogrammare, oldDescrizione: this.tsDaRiprogrammare.descrizione});
      this.tsDaRiprogrammare = null;
      this.showRiProgrammaTask = false;
      this.vecchiaDataTs = new Date();
      this.nuovaDataTs = new Date();
    },
    getCaricoMassimoSettimana(ore, esecutore) {
      let oreGiornaliere = ore / 5;
      let gg = this.getGiorniSettimana().length;
      let orario = Math.round(gg * oreGiornaliere);
      if (esecutore.oreFerie) {
        orario -= esecutore.oreFerie.ore
      }

      let tuttiGiorni = this.getGiorniSettimana();
      for(let giorno of tuttiGiorni){
        if(this.isItalianHoliday(moment(giorno).format('YYYY-MM-DD'))){
          orario-=oreGiornaliere;
        }

      }

      if (orario < 0)
        orario = 0;
      return orario
    },
    getCaricoMassimoSettimanaProssima(ore, esecutore) {
      let oreGiornaliere = ore / 5;
      let gg = this.getGiorniSettimanaProssima().length;
      let orario = Math.round(gg * oreGiornaliere);
      if (esecutore.oreFerieSettimanaProssima) {
        orario -= esecutore.oreFerieSettimanaProssima.ore
      }

      let tuttiGiorni = this.getGiorniSettimanaProssima();
      for(let giorno of tuttiGiorni){
        if(this.isItalianHoliday(moment(giorno).format('YYYY-MM-DD'))){
          orario-=oreGiornaliere;
        }
      }

      if (orario < 0)
        orario = 0;
      return orario
    },
    getGiorniSettimana() {
      const today = new Date();
      const days = [];
      const todayDay = today.getDay();

      const daysUntilTuesday = (9 - todayDay) % 7 || 7;

      for (let i = 0; i < daysUntilTuesday; i++) {
        const current = new Date(today);
        current.setDate(today.getDate() + i);

        const day = current.getDay();
        if (day !== 0 && day !== 6) {
          days.push(current);
        }
      }

      return days;
    },

    getGiorniSettimanaProssima() {
      const today = new Date();
      const result = [];

      const todayDay = today.getDay();
      const daysUntilNextTuesday = (9 - todayDay) % 7 || 7;

      const startDate = new Date(today);
      startDate.setDate(today.getDate() + daysUntilNextTuesday);

      for (let i = 0; i < 7; i++) {
        const current = new Date(startDate);
        current.setDate(startDate.getDate() + i);

        const day = current.getDay();
        if (day !== 0 && day !== 6) {
          result.push(current);
        }
      }

      return result;
    },

    isItalianHoliday(date) {
      const d = date instanceof Date ? date : new Date(date);
      const day = d.getDate();
      const month = d.getMonth() + 1; // Gennaio = 0

      const fixedHolidays = [
        '1-1',   // Capodanno
        '6-1',   // Epifania
        '25-4',  // Liberazione
        '1-5',   // Festa del Lavoro
        '2-6',   // Festa della Repubblica
        '15-8',  // Ferragosto
        '1-11',  // Ognissanti
        '8-12',  // Immacolata
        '25-12', // Natale
        '26-12'  // Santo Stefano
      ];

      if (fixedHolidays.includes(`${day}-${month}`)) {
        return true;
      }

      // Pasqua e Pasquetta cambiano ogni anno → va calcolata
      const easter = this.getEasterDate(d.getFullYear());
      const pasquetta = new Date(easter);
      pasquetta.setDate(easter.getDate() + 1);

      return (
          this.sameDate(d, easter) ||
          this.sameDate(d, pasquetta)
      );
    },

    getEasterDate(year) {
      // Algoritmo di Gauss
      const f = Math.floor,
          G = year % 19,
          C = f(year / 100),
          H = (C - f(C / 4) - f((8 * C + 13) / 25) + 19 * G + 15) % 30,
          I = H - f(H / 28) * (1 - f(29 / (H + 1)) * f((21 - G) / 11)),
          J = (year + f(year / 4) + I + 2 - C + f(C / 4)) % 7,
          L = I - J,
          month = 3 + f((L + 40) / 44),
          day = L + 28 - 31 * f(month / 4);

      return new Date(year, month - 1, day);
    },

    sameDate(d1, d2) {
      return (
          d1.getDate() === d2.getDate() &&
          d1.getMonth() === d2.getMonth() &&
          d1.getFullYear() === d2.getFullYear()
      );
    },


    annullaProgramma() {
      let tasks = this.$store.getters.getAllTasks();
      this.showProgrammaTask = false;
      this.$store.dispatch("tasksLoaded", tasks);
    },
    programmaSettimanaInCorso() {
      this.programmaPayload.prossimaSettimana = false;
      this.showProgrammaTask = false;
      this.$store.dispatch("updateStatus", {
        ...this.programmaPayload
      });
    },
    programmaSettimanaProssima() {
      this.programmaPayload.prossimaSettimana = true;
      this.showProgrammaTask = false;
      this.$store.dispatch("updateStatus", {
        ...this.programmaPayload
      });
    },
    creaNuovoTS() {
      this.task.descrizione = undefined;
      this.task.richiedeApprovazione = undefined;
      this.task.orePreviste = undefined;
      this.task.orePreviste = undefined;
      this.showCloseTicket = false;
      this.$store.dispatch('creaTaskSprint', {
        userId: this.task.idOwner,
        status: "BACKLOG",
        duplica: true,
        task: {...this.task}
      });
    },

    chiudiTicket() {
      this.$store.dispatch('chiudiTicket', {
        idOwner: this.task.idOwner,
        idTicket: this.task.idTicket,
        force: this.force,
        inviaNotifica: true
      });
      this.showCloseTicket = false;
    },
    startChiudiDefinitivoTicket() {
      this.showChiudiDefinitivo = true;
    },
    chiudiDefinitivoTicket() {
      this.$store.dispatch('chiudiTicket', {
        idOwner: this.task.idOwner,
        idTicket: this.task.idTicket,
        force: true,
        messaggioChiusuraTicket: this.messaggioChiusuraDefinitivo,
        inviaNotifica: this.inviaNotifica
      });
      this.showChiudiDefinitivo = false;
      this.showCloseTicket = false;
    },


    toggleTab($event, index) {
      if (this.activeTab === index) {
        const button = $event.target
        if (!button) return;
        button.classList.remove("p-tab-active");
        const controlledElementId = button.getAttribute("aria-controls");
        if (!controlledElementId) return;
        const controlledElement = document.getElementById(controlledElementId);
        if (!controlledElement) return;
        controlledElement.style.display = 'none'
        this.activeTab = null;
        $('.p-tablist-active-bar').css({width: 0});
      } else {
        const button = $event.target
        if (!button) return;
        const controlledElementId = button.getAttribute("aria-controls");
        if (!controlledElementId) return;
        const controlledElement = document.getElementById(controlledElementId);
        if (!controlledElement) return;
        controlledElement.style = {}
        this.activeTab = index;
        $('.p-tablist-active-bar').css({width: button.offsetWidth});
      }
    },
    async load() {
      document.title = 'Dashboard PM';
      this.loading = false;
      let filters = {
        //TODO: Impostare dinamicamente userID
        id_owner: 33,
        status: this.taskStatus
      }
      this.$store.dispatch("loadEsecutori", filters);
      this.$store.dispatch("loadFeriePermessi", filters);
      // setInterval(()=>{
      //   let lastFetch=this.$store.getters.getLastFetch();
      //
      //   this.$store.dispatch('refreshTasks',{
      //     lastFetch:lastFetch,
      //     isPM:true
      //   });
      //   this.$store.dispatch("loadNotifiche");
      // }, 300000)
    },
    filtraAmbiti(ambito) {
      if (!this.filtriClient || (this.filtriClient?.idEsecutore === -1 && this.filtriClient?.idLavoro === -1 && this.filtriClient?.idAttivita === -1)) {
        let count = ambito.esecutori.filter(es => es.descrizione.toLowerCase().includes(this.filtroInline)).length
        ambito.count = count;
        return count > 0
      } else {
        if (this.filtriClient?.idEsecutore !== -1) {
          let count = ambito.esecutori.filter(es => es.descrizione.toLowerCase().includes(this.filtroInline)).length
          ambito.count = count;
          return count > 0;
        }
        if (this.filtriClient.idLavoro !== -1 && this.filtriClient.idAttivita === -1) {
          //FILTTRO SOLO PER LAVORO
          let show = false;
          let count = 0;
          ambito.esecutori.forEach(es => {
            let taskEsecutore = this.$store.getters.getAllTasksForUser(es.id_account);
            let c = taskEsecutore.filter(ts => ts.idTicketParent == this.filtriClient.idLavoro).length;
            if (c > 0) {
              show = true;
              count++
            }
          });
          ambito.count = count;
          return show;
        }
        if (this.filtriClient.idLavoro === -1 && this.filtriClient.idAttivita !== -1) {
          //FILTTRO SOLO PER ATTIVITA
          let show = false;
          let count = 0;
          ambito.esecutori.forEach(es => {
            let taskEsecutore = this.$store.getters.getAllTasksForUser(es.id_account);
            let c = taskEsecutore.filter(ts => ts.idTicket == this.filtriClient.idAttivita).length;
            if (c > 0) {
              show = true;
              count++
            }
          });
          ambito.count = count;
          return show;
        }
        if (this.filtriClient.idLavoro !== -1 && this.filtriClient.idAttivita !== -1) {
          //FILTTRO PER LAVORO E ATTIVITA
          let show = false;
          let count = 0;
          ambito.esecutori.forEach(es => {
            let taskEsecutore = this.$store.getters.getAllTasksForUser(es.id_account);
            let c = taskEsecutore.filter(ts => ts.idTicket == this.filtriClient.idAttivita && ts.idTicketParent == this.filtriClient.idLavoro).length;
            if (c > 0) {
              show = true;
              count++
            }
          });
          ambito.count = count;
          return show;
        }
      }
    },
    filtraEsecutori(esecutore) {
      if (!this.filtriClient || (this.filtriClient?.idEsecutore === -1 && this.filtriClient?.idLavoro === -1 && this.filtriClient?.idAttivita === -1))
        return esecutore.descrizione.toLowerCase().includes(this.filtroInline)
      else {
        let taskEsecutore = this.$store.getters.getAllTasksForUser(esecutore.id_account);
        if (this.filtriClient?.idEsecutore !== -1)
          return esecutore.id_account == this.filtriClient?.idEsecutore;
        if (this.filtriClient.idLavoro !== -1 && this.filtriClient.idAttivita === -1) {
          //FILTTRO SOLO PER LAVORO
          return taskEsecutore.some(ts => ts.idTicketParent == this.filtriClient.idLavoro);
        }
        if (this.filtriClient.idLavoro === -1 && this.filtriClient.idAttivita !== -1) {
          //FILTTRO SOLO PER ATTIVITA
          return taskEsecutore.some(ts => ts.idTicket == this.filtriClient.idAttivita);
        }
        if (this.filtriClient.idLavoro !== -1 && this.filtriClient.idAttivita !== -1) {
          //FILTTRO PER LAVORO E ATTIVITA
          return taskEsecutore.some(ts => ts.idTicket == this.filtriClient.idAttivita && ts.idTicketParent == this.filtriClient.idLavoro);
        }
      }
    },
    reloadManuale() {
      let lastFetch = this.$store.getters.getLastFetch();

      this.$store.dispatch('refreshTasks', {
        lastFetch: lastFetch,
        isPM: true
      });
      this.$store.dispatch("loadNotifiche");
    }
  }
};
</script>